import { Amplify } from 'aws-amplify';
import { signOut, fetchAuthSession, signInWithRedirect, getCurrentUser, signIn } from 'aws-amplify/auth'

export class CognitoService {
    constructor() {
        AmplifyAuthSetup();
    }

    signIn = (username: string, password: string) => signIn({ username: username, password: password });
    signInWithGoogle = () => signInWithRedirect({ provider: "Google", customState: "signin-google-state", options: { preferPrivateSession: true } });
    signOut = async () => signOut({ global: false });
    getCurrentSession = () => fetchAuthSession();
    getCurrentUser = () => getCurrentUser();
}

const AmplifyAuthSetup = () => {
    
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: import.meta.env.PUBLIC_CI_USER_POOL_ID,
                userPoolClientId: import.meta.env.PUBLIC_CI_USER_POOL_CLIENT_ID,
                signUpVerificationMethod: "code",
                loginWith: {
                    oauth: {
                        domain: import.meta.env.PUBLIC_CI_OAUTH_DOMAIN,
                        scopes: ["openid", "email", "profile"],
                        redirectSignIn: [import.meta.env.PUBLIC_CI_REDIRECT_SIGNIN_URL],
                        redirectSignOut: [import.meta.env.PUBLIC_CI_REDIRECT_SIGNOUT_URL],
                        responseType: "code",
                        providers: ["Google"]
                    }
                }
            },
        },
    });
}